<template>
  <div class="inter-cut-manage">
    <subfield>
      <template slot="list">
        <trees type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        <trees type="INTER_CUT" @getAssets="getAssets" :list="ictList"></trees>
      </template>
      <template slot="content">
        <enfold-ucd>
          <template slot="up">
            <div class="c-u-left">
              <img src="@/assets/images/public/public_add.png" @click="$router.push({name: 'NewInterCut', params: {event: 'ADD'}})" class="icon" alt />
              <img src="@/assets/images/public/public_delete.png" @click="handleDelete()" class="icon" alt />
            </div>
            <div class="c-u-right">
              <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = undefined">
                <i slot="suffix" class="el-icon-search" @click="keyword && search(keyword)"></i>
              </el-input>
              <img src="@/assets/images/public/public_filter.png" @click="filter" class="icon" alt />
            </div>
          </template>
          <template slot="center">
            <el-table ref="multipleTable" :data="deviceList" style="width: 100%" height="100%" @selection-change="selectionChange" v-loading="loading">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="name" :label="$t('csl1')" width="100"></el-table-column>
              <el-table-column prop="name" :label="$t('csl2')">
                <template slot-scope="scope">{{`${scope.row.content[0].ic_name}`}}</template>
              </el-table-column>
              <el-table-column prop="name" :label="$t('csl3')" width="100">
                <template slot-scope="scope">{{`${$t('csl4')}-${scope.row.content[0].playcount}`}}</template>
              </el-table-column>
              <el-table-column prop="create_time" :label="$t('csl5')" width="180"></el-table-column>
              <el-table-column prop="u_name" :label="$t('csl6')" width="100"></el-table-column>
              <el-table-column :label="$t('csl7')" width="120">
                <template slot-scope="scope">
                  <div class="operation">
                    <img class="icon" src="@/assets/images/public/public_edit.png" @click="handleEdit(scope.$index, scope.row)" alt />
                    <img class="icon" src="@/assets/images/public/public_delete.png" @click="handleDelete(scope.$index, scope.row)" alt />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template slot="down">
            <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
          </template>
        </enfold-ucd>
      </template>
    </subfield>
    <form-dialog :dialogVisible="FormDialogVisible" @closeDialog="FormCloseDialog" :title="icTitle" dWidth="400px">
      <div class="form-dialog">
        <el-form :model="icForm" :rules="rules" ref="icForm" label-width="100px">
          <el-form-item :label="$t('csl8')" prop="name">
            <el-input v-model="icForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('icForm')" round>{{$t('csl9')}}</el-button>
            <el-button type="primary" @click="submitForm('icForm')" round>{{$t('csl10')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('csl11')">
      <div class="dd-dialog">{{$t('csl12')}} ( {{itemIc.name}} )</div>
    </del-dialog>
    <del-dialog :dialogVisible="icDelDialogVisible" @closeDialog="icDelCloseDialog" :title="$t('csl13')">
      <div class="dd-dialog">{{$t('csl14')}}</div>
    </del-dialog>
    <msg-dialog :dialogVisible="msgDialogVisible" @closeDialog="closeDialog" top="20vh" :title="$t('csl15')">
      <div class="filter">
        <div class="title">{{$t('csl16')}}</div>
        <div class="content">
          <el-date-picker v-model="filterDate.date" type="daterange" :range-separator="$t('csl17')" :start-placeholder="$t('csl18')" :end-placeholder="$t('csl19')" size="mini"></el-date-picker>
        </div>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import trees from '@/components/basics/Trees'
import pagination from '@/components/basics/Pagination'
import EnfoldUcd from '@/components/basics/EnfoldUCD'
import FormDialog from '@/components/basics/FormDialog'
import DelDialog from '@/components/basics/DelDialog'
import { mPagination } from "@/components/basics/mixins";
import MsgDialog from '@/components/basics/MsgDialog'
import { dateFormatting } from "@/assets/scripts/dateFormatting"
export default {
  name: 'InterCutManage',
  mixins: [mPagination],
  data() {
    return {
      groupList: [],
      loading: false,
      multipleSelection: [],
      deviceList: [],
      ictList: [],
      delIds: "",
      FormDialogVisible: false,
      DelDialogVisible: false,
      icDelDialogVisible: false,
      msgDialogVisible: false,
      icForm: {
        name: ""
      },
      rules: {
        name: [
          { required: true, message: this.$t('csl20'), trigger: 'blur' }
        ]
      },
      icTitle: "",
      itemIc: {
        id: "",
        name: "",
      },
      treesEvent: "", // 树结构传递过来的事件add\edit\del
      filterDate: {
        date: [new Date(), new Date()]
      },
      ie_ds: undefined
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.getictList();
    this.getDeviceList();
  },
  methods: {
    // 获取插播类型列表
    getictList() {
      this.$http.post("/admin/InterCut/itList", {}, data => {
        this.ictList = data.list;
      });
    },
    // 获取播放事件列表
    getDeviceList(args = {
      group_ids: this.groupIds,
      limit: this.limit,
      page: this.page,
      it_id: this.itemIc.id,
      ie_ds: this.ie_ds,
      key_word: this.keyword
    }) {
      this.loading = true;
      this.$http.post("/admin/InterCut/ieList", args, data => {
        this.deviceList = data.list ? data.list : [];
        this.current = parseInt(data.count);
        this.loading = false;
      });
    },
    getAssets(ids) {
      if (ids.type === "GROUP") {
        this.groupId = ids.id;
      }
      if (ids.type === "INTER_CUT") {
        this.treesEvent = ids.event;
        this.itemIc.id = ids.id;
        switch (ids.event) {
          case 'add': this.addInterCutType(); break;
          case 'del': this.delInterCutType(ids.id); break;
          case 'edit': this.editInterCutType(ids.id); break;
          default:
            break;
        }
      }
      // console.log(ids);
      ids.id && this.getDeviceList();
    },
    addInterCutType() {
      this.icTitle = this.$t('csl21');
      this.icForm.name = "";
      this.FormDialogVisible = true;
    },
    editInterCutType(id) {
      this.icForm.name = this.interCutTypeName(id);
      this.icTitle = this.$t('csl22');
      this.FormDialogVisible = true;
    },
    interCutTypeName(id) {
      return this.ictList.find(item => item.id === id).name;
    },
    delInterCutType(id) {
      this.itemIc.name = this.interCutTypeName(id);
      this.DelDialogVisible = true;
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post("/admin/InterCut/delInterCutType", { id: this.itemIc.id }, data => {
          console.log(data);
          this.getictList();
        });
      }
      this.DelDialogVisible = false;
    },
    handleDelete(index, row) {
      console.log(this.multipleSelection);
      this.delIds = "";
      if (index || row) {
        this.delIds = row.id;
      } else {
        this.delIds = this.multipleSelection.map((ele) => ele.id).join(',');
      }
      this.icDelDialogVisible = true;
    },
    icDelCloseDialog(isConfirm) {
      console.log(isConfirm, this.delIds);
      if (isConfirm) {
        this.delIds ? this.$http.post("/admin/InterCut/delInterCutEvent", { ids: this.delIds }, data => {
          console.log(data);
          this.getDeviceList();
        }) : this.$msg({ showClose: true, message: this.$t('csl23'), type: 'warning' });
      }
      this.icDelDialogVisible = false;
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    search(keyword) {
      this.keyword = keyword;
      this.getDeviceList();
    },
    closeDialog(isConfirm) {
      if (isConfirm) {
        this.ie_ds = encodeURIComponent(JSON.stringify([`${dateFormatting(this.filterDate.date[0])}`, `${dateFormatting(this.filterDate.date[1])}`]));
        this.getFabuList();
      }
      this.msgDialogVisible = false;
    },
    filter() {
      this.msgDialogVisible = true;
    },
    currentChange(val) {
      console.log(val);
      this.page = val;
      this.getDeviceList();
    },
    FormCloseDialog() {
      this.FormDialogVisible = false;
    },
    resetForm(icForm) {
      this.$refs[icForm].resetFields();
      this.FormDialogVisible = false;
    },
    handleDetail(index, row) {
      console.log(index, row);
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.$router.push({
        name: 'NewInterCut',
        params: {
          event: 'EDIT',
          icItem: row
        }
      });
    },
    submitForm(icForm) {
      this.$refs[icForm].validate((valid) => {
        if (valid) {
          this.treesEvent === "add" && this.$http.post("/admin/InterCut/addInterCutType", { name: this.icForm.name }, data => {
            console.log(data);
            this.getictList();
            this.resetForm(icForm);
          });
          this.treesEvent === "edit" && this.$http.post("/admin/InterCut/editInterCutType", { id: this.itemIc.id, name: this.icForm.name }, data => {
            console.log(data);
            this.getictList();
            this.resetForm(icForm);
          });
          this.FormDialogVisible = false;
        } else {
          return false;
        }
      });
    },
  },
  components: {
    subfield,
    trees,
    pagination,
    EnfoldUcd,
    FormDialog,
    DelDialog,
    MsgDialog
  }
}
</script>

<style lang="scss" scoped>
.inter-cut-manage {
  width: 100%;
  height: 100%;
  .c-u-right {
    display: flex;
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }
    /deep/ .el-input__suffix {
      line-height: 30px;
      color: var(--theme-color-customized-1);
      font-size: 16px;
      right: 10px;
    }
    .icon {
      margin-right: 0px;
      margin-left: 25px;
    }
  }
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .icon {
      margin: 0px;
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    margin-right: 25px;
  }
  .filter {
    padding-left: 12px;
    .title {
      text-align: center;
      font-size: 16px;
      color: var(--theme-color-customized-1);
    }
    .title ~ .title {
      padding-top: 8px;
    }
    .content {
      padding-top: 8px;
    }
  }
}
</style>
